module.exports = __webpack_public_path__ + "static/Dafodil-02-d2ad8b7f0477b94e77e93f7cef287761.png";